import React from 'react';
import './ApexPricing_Boxes.css';
import { HiBadgeCheck } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';

const ApexPricing_Boxes = () => {
  const { t, i18n } = useTranslation();

  const pricingData = [
    {
      titleKey: 'pricing_plan_1week_title',
      descKey: 'pricing_plan_1week_desc',
      features: [
        'undetected_pricing',
        'custom_build',
        'hotkeys_pricing',
        'updates_support',
      ],
      linkEn: "https://oplata.info/asp2/pay_wm.asp?id_d=5475943&lang=en-EN",
      linkRu: "https://oplata.info/asp2/pay_wm.asp?id_d=5475943&lang=en-EN"
    },
    {
      titleKey: 'pricing_plan_1month_title',
      descKey: 'pricing_plan_1month_desc',
      features: [
        'undetected_pricing',
        'custom_build',
        'hotkeys_pricing',
        'updates_support',
      ],
      linkEn: "https://oplata.info/asp2/pay_wm.asp?id_d=5475948&lang=en-EN",
      linkRu: "https://oplata.info/asp2/pay_wm.asp?id_d=5475948&lang=en-EN"
    },
    {
      titleKey: 'pricing_plan_3months_title',
      descKey: 'pricing_plan_3months_desc',
      features: [
        'undetected_pricing',
        'custom_build',
        'hotkeys_pricing',
        'updates_support',
      ],
      linkEn: "https://oplata.info/asp2/pay_wm.asp?id_d=5476332&lang=en-EN",
      linkRu: "https://oplata.info/asp2/pay_wm.asp?id_d=5476332&lang=en-EN"
    },
  ];

  const getLink = (plan) =>
    i18n.language === 'ru' ? plan.linkRu : plan.linkEn;

  return (
    <div className="apex-pricing-boxes-component">
      {/* Pricing Wrapper */}
      <div className="apex-pricing-boxes-wrapper">
        <div className="apex-pricing-boxes-inner">
          {pricingData.map((plan, idx) => {
            const parts = t(plan.descKey).split('/');
            const price = parts[0].trim();
            const period = parts[1] ? parts[1].trim() : '';
            return (
              <div key={idx} className="apex-pricing-boxes-box">
                <div className="apex-pricing-box-content">
                  <h3>{t(plan.titleKey)}</h3>
                  <p className="apex-pricing-boxes-description">
                    <span className="apex-price-number">{price}</span>
                    {period && <span className="apex-pricing-boxes-period"> / {period}</span>}
                  </p>
                  <div className="apex-pricing-boxes-features">
                    {plan.features.map((fKey, i) => (
                      <div key={i} className="apex-pricing-boxes-feature">
                        <HiBadgeCheck className="apex-feature-icon" />
                        <span>{t(fKey)}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="apex-pricing-box-buttons">
                  <a href={getLink(plan)} target="_blank" rel="noopener noreferrer">
                    <button 
                      className="apex-pricing-boxes-button apex-purchase-software-button"
                    >
                      {t('purchase_software')}
                    </button>
                  </a>
                  <a href={getLink(plan)} target="_blank" rel="noopener noreferrer" style={{ marginTop:'5px' }}>
                    <button className="apex-pricing-boxes-button">
                      {t('purchase_hardware')}
                    </button>
                  </a>
                </div>
              </div>
            );
          })}
          {/* Lifetime Access Box */}
          <div className="apex-pricing-boxes-box apex-lifetime-box">
            <div className="apex-pricing-box-content">
              <h3 className="apex-lifetime-access-title">{t('lifetime_access')}</h3>
              {i18n.language === 'ru' ? (
                <p className="apex-lifetime-original-price">7000 ₽</p>
              ) : (
                <p className="apex-lifetime-original-price">{t('lifetime_original_price')}</p>
              )}
              {i18n.language === 'ru' ? (
                <p className="apex-pricing-boxes-description">
                  <span className="apex-price-number">4000 ₽</span>{' '}
                  <span className="apex-limited-offer">{t('limited_offer')}</span>
                </p>
              ) : (
                <p className="apex-pricing-boxes-description">
                  <span className="apex-price-number">50$</span>{' '}
                  <span className="apex-limited-offer">{t('limited_offer')}</span>
                </p>
              )}
              <div className="apex-lifetime-text" dangerouslySetInnerHTML={{ __html: t('lifetime_text') }}></div>
            </div>
            <div className="apex-pricing-box-buttons">
              <a
                href="https://oplata.info/asp2/pay_wm.asp?id_d=5476341&lang=en-EN"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button 
                  className="apex-pricing-boxes-button apex-purchase-software-button"
                >
                  {t('purchase_software')}
                </button>
              </a>
              <a
                href="https://oplata.info/asp2/pay_wm.asp?id_d=5476341&lang=en-EN"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginTop:'5px' }}
              >
                <button className="apex-pricing-boxes-button">
                  {t('purchase_hardware')}
                </button>
              </a>
            </div>
          </div>
        </div> {/* End of .apex-pricing-boxes-inner */}
      </div> {/* End of .apex-pricing-boxes-wrapper */}
    </div>
  );
};

export default ApexPricing_Boxes;